import moment from "moment";

// If your local time is UTC+5:30 → "8:00 PM"
export function convertUTCTo12Hour(utcTime) {
  if (!utcTime) return null;
  const [hours, minutes] = utcTime.split(":").map(Number);

  // Create a date object in UTC
  const date = new Date();
  date.setUTCHours(hours, minutes, 0, 0);

  // Get local hours and minutes
  const localHours = date.getHours();
  const localMinutes = date.getMinutes().toString().padStart(2, "0");

  const ampm = localHours >= 12 ? "PM" : "AM";
  const hour12 = localHours % 12 || 12;

  return `${hour12}:${localMinutes} ${ampm}`;
}

export function timeHelper(time) {
  if (!time) return null;
  console.log(time, "time");
  const [hours, minutes] = time.split(":").map(Number);

  let dateObj = new Date();
  dateObj.setUTCHours(hours + 5);
  dateObj.setUTCMinutes(minutes + 30);

  // Get local time values
  const localHours = dateObj.getUTCHours();
  const localMinutes = dateObj.getUTCMinutes();
  // Convert to 12-hour format
  const displayHours = ((localHours + 11) % 12) + 1; // Converts 0–23 to 1–12
  const am_pm = localHours >= 12 ? "pm" : "am";
  const paddedMinutes = localMinutes.toString().padStart(2, "0");

  const outputDateString = `${displayHours}:${paddedMinutes} ${am_pm.toLocaleUpperCase()}`;

  return outputDateString;
}

export function dateHelper(a) {
  if (!a) return null;
  const dateObj = new Date(a);
  const outputDateString = moment(a).format("DD/MM/YYYY");
  return outputDateString;
}
